import { render, staticRenderFns } from "./CategoryNavigation.vue?vue&type=template&id=145bb395&lang=pug&"
import script from "./CategoryNavigation.vue?vue&type=script&lang=js&"
export * from "./CategoryNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports